import type React from 'react'
import type { IconProps } from './types'

const DashboardIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M13 9V3H21V9H13ZM3 13V3H11V13H3ZM13 21V11H21V21H13ZM3 21V15H11V21H3ZM5 11H9V5H5V11ZM15 19H19V13H15V19ZM15 7H19V5H15V7ZM5 19H9V17H5V19Z' />
	</svg>
)

export default DashboardIcon
